var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navBox"},[_c('img',{staticClass:"navBox-bg",attrs:{"src":_vm.headerImg,"alt":"背景"}}),_c('div',{staticClass:"navBox-mask"}),_c('div',{staticClass:"navBox-content"},[_c('p',{staticClass:"navBox-title"},[_vm._v(_vm._s(_vm.headerTitle))]),_c('p',{staticClass:"navBox-desc"},[_vm._v(_vm._s(_vm.headerDesc))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }